module.exports = __webpack_public_path__ + "img/instagram.79dce6f1.svg";